import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const DocumentformatServiceConfig = {
  name: "Documentformat",
  annotations: []
} as ServiceConfig;